<template>
  <b-btn class="d-flex align-items-center" variant="outline-secondary" size="sm" @click="saveColumns"
         title="Save columns">
    <icon name="save" class="mr-1"></icon>
    {{$t('buttons.common.save_columns')}}
  </b-btn>
</template>

<script>
  import { handlerResponse, setNotifyData } from '@/helpers/commonHelpers';

  export default {
    props: {grid: {type: Object, required: true}, gridName: {type: String, required: true}},
    data() {
      return {}
    },
    methods: {
      saveColumns() {
        const grid = this.grid,
          grid_name = this.gridName,
          allColumns = grid.columnApi.getAllGridColumns(),
          displayedColumns = grid.columnApi.getAllDisplayedColumns();
        const savedData = {
          grid_name,
          displayed_columns: displayedColumns.map(item => item.colDef.field),
          all_columns: allColumns.map(item => item.colDef.field)
        };
        this.$http.put(`accounts/update_user_setting/`, savedData).then(handlerResponse).then((response) => {
          const user = response.username;
          this.$notify(setNotifyData('Success', `Columns for user ${user} has been saved!`, 'success'));
        }).catch(error => {
          console.log(error);
          this.$notify(setNotifyData('', 'Unable to save columns', 'error'));
        });
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/common/SaveColumnsBtn.vue